/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_N8n_QuestionInputs */

const en_faq_n8n_question = /** @type {(inputs: Faq_N8n_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you work with n8n?`)
};

const lv_faq_n8n_question = /** @type {(inputs: Faq_N8n_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai strādājat ar n8n?`)
};

/**
* | output |
* | --- |
* | "Do you work with n8n?" |
*
* @param {Faq_N8n_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_n8n_question = /** @type {((inputs?: Faq_N8n_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_N8n_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_n8n_question(inputs)
	return en_faq_n8n_question(inputs)
});